module.exports = __webpack_public_path__ + "static/media/canari_logo_covid.1fd1e85d.png";